import React, { useContext } from 'react';
import TopBar from '../components/TopBar';
import layoutStyles from '../styles/layout.module.css';
import styles from './Account.module.css';
import { useNavigate } from 'react-router-dom';
import { FaChevronRight, FaEnvelope, FaIdCard, FaKey, FaUser } from 'react-icons/fa';
import { UserContext } from '../App';

function Item({ icon: Icon, label, detail, onClick, color = '#111827' }) {
  return (
    <button onClick={onClick} className={styles.itemButton}>
      <span className={styles.buttonLabel}>
        {Icon ? <Icon size={18} color={color} /> : null}
        <span className={styles.buttonCopy}>
          <span className={styles.buttonText}>{label}</span>
          <span className={styles.buttonDetail}>{detail}</span>
        </span>
      </span>
      <span className={styles.chevron} aria-hidden>
        <FaChevronRight />
      </span>
    </button>
  );
}

export default function Account() {
  const navigate = useNavigate();
  const appUser = useContext(UserContext);
  const fullName = [appUser?.firstName, appUser?.lastName].filter(Boolean).join(' ').trim() || 'Not set yet';
  const email = appUser?.email || 'Not available';

  return (
    <div className={layoutStyles.detailPage}>
      <TopBar variant="back" backLabel="Back" onBack={() => (window.history.length > 2 ? navigate(-1) : navigate('/fan/settings'))} rightActionLabel="Home" onRightAction={() => navigate('/home')} />

      <div className={`${layoutStyles.detailMain} ${styles.pageShell}`.trim()}>
        <div className={styles.pageInner}>
          <section className={styles.heroCard}>
            <span className={styles.eyebrow}>Account</span>
            <h1 className={styles.title}>Manage your fan profile</h1>
            <p className={styles.subtitle}>Keep your name, email, and sign-in details current so your account stays secure and recognizable across the app.</p>
            <div className={styles.summaryGrid}>
              <div className={styles.summaryCard}>
                <span><FaUser /> Name</span>
                <strong>{fullName}</strong>
              </div>
              <div className={styles.summaryCard}>
                <span><FaEnvelope /> Email</span>
                <strong>{email}</strong>
              </div>
            </div>
          </section>

          <section className={styles.sectionCard}>
            <div className={styles.sectionHeader}>
              <div>
                <span className={styles.sectionEyebrow}>Profile Settings</span>
                <h2 className={styles.sectionTitle}>Update your details</h2>
              </div>
            </div>
            <div className={styles.list}>
              <Item icon={FaIdCard} color="#2563eb" label="Change Name" detail="Update the first and last name shown around the app." onClick={() => navigate('/account/name')} />
              <Item icon={FaEnvelope} color="#16a34a" label="Change Email" detail="Securely change the email address tied to this account." onClick={() => navigate('/account/email')} />
              <Item icon={FaKey} color="#d97706" label="Change Password" detail="Refresh your password and keep your account protected." onClick={() => navigate('/account/password')} />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
